var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoPop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#00430B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55322 51.9533C14.1594 45.3331 21.8236 41 30.4998 41C38.9253 41 46.3965 45.0863 51.0395 51.3853C45.6248 56.713 38.1962 60 29.9998 60C22.0988 60 14.9111 56.9456 9.55322 51.9533Z",
    fill: "#90F50F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8515 20.4578C39.8606 19.0652 39.7392 17.1041 38.4875 15.852C37.1336 14.4977 34.9622 14.4594 33.5636 15.7434V15.5645C33.5636 13.597 31.967 12 30 12C28.033 12 26.4364 13.597 26.4364 15.5645V15.7434C25.0378 14.4658 22.8664 14.4977 21.5125 15.852C20.2544 17.1105 20.133 19.0652 21.1485 20.4578C19.3795 20.6622 18 22.1698 18 23.9968C18 25.9643 19.5966 27.5614 21.5636 27.5614H21.7424L21.5189 27.7849C20.1267 29.1775 20.1267 31.4325 21.5189 32.8251C22.8792 34.1858 25.0761 34.2177 26.4683 32.9018C26.6982 34.6457 28.1927 36 30 36C31.8073 36 33.3018 34.6521 33.5317 32.9018C34.9303 34.2113 37.1208 34.1858 38.4811 32.8251C39.8733 31.4325 39.8733 29.1775 38.4811 27.7849L38.2576 27.5614H38.4364C40.4034 27.5614 42 25.9643 42 23.9968C41.9936 22.1698 40.6205 20.6622 38.8515 20.4578Z",
    fill: "#90F50F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoPop);
export default __webpack_public_path__ + "static/media/user-logo-pop.5626a010f0b8f8272b76b34e03d3c535.svg";
export { ForwardRef as ReactComponent };